import './ProfileExistPopup.scss';

import { InfoCircleOutlined } from '@ant-design/icons';
import { useNavigate } from '@reach/router';
import { Modal } from 'antd';

import { showEmailVerificationInstruction } from '../../services/navigation-service/navigation.service';
import Button from '../Button/Button';

const ProfileExistPopup = ({
  userType,
  modalStatus,
  closable,
  setModalStatus,
  closeSignupModal,
  modalRef
}) => {
  const navigate = useNavigate();

  const closeModal = () => {
    setModalStatus && setModalStatus(false);
  };

  const redirectAndClose = () => {
    closeModal();
    closeSignupModal && closeSignupModal(modalRef);
    userType && userType === 'SOI'
      ? showEmailVerificationInstruction()
      : navigate('/?reactivate=true');
  };

  return (
    <Modal
      className="profile-exist-popup-modal"
      open={modalStatus}
      footer={false}
      centered
      maskClosable={false}
      onCancel={closeModal}
      closable={closable ? closable : false}
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <InfoCircleOutlined className="popup-icon" />
      <div className="profile-exist-popup-header">
        {userType && userType === 'SOI' ? (
          'An account registered to this email already exists. Please check your inbox to log in.'
        ) : (
          <span>
            You already have an account with us!
            <br />
            <strong>Check your email for a reactivation link </strong>
            <br />
            <br />
            Or log in below
          </span>
        )}
      </div>
      {userType && userType === 'SOI' ? (
        <Button text="Okay" onClick={redirectAndClose} />
      ) : (
        <Button text="Proceed to login" onClick={redirectAndClose} />
      )}
    </Modal>
  );
};

export default ProfileExistPopup;
